/* ============================================
   GLOW Skincare — Scroll Reveal (Unified)
   Lightweight IntersectionObserver animation
   Handles both .glow-reveal and data-section-animation
   No dependencies, ~3KB, respects reduced motion
   ============================================ */
(function() {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    /* Remove opacity:0 for reduced motion users */
    document.querySelectorAll('[data-section-animation]').forEach(function(el) {
      el.style.animation = 'none';
      el.style.opacity = '1';
    });
    return;
  }

  var SECTION_SELECTORS = [
    '[id*="trust_certs"]',
    '[id*="featured_collection"]',
    '[id*="skin_diagnostic"]',
    '[id*="testimonials"]',
    '[id*="ugc_videos"]',
    '[id*="collections_concern"]',
    '[id*="brand_innovation"]',
    '[id*="guarantees"]',
    '[id*="newsletter_incentive"]',
    '[id*="faq"]'
  ];

  var STAGGER_MAP = [
    { parent: '.trust-certs__grid', children: '.trust-certs__badge' },
    { parent: '.featured-collection__grid', children: '.grid__item' },
    { parent: '.collections-concern__grid, .collections-concern__cards', children: '[class*="card"], .grid__item' },
    { parent: '.guarantees__grid, .guarantees__cards', children: '[class*="card"], .grid__item' }
  ];

  /* --- Phase D: reveal split-lines inside a section --- */
  function revealSplitLines(sectionEl) {
    var splitHeadings = sectionEl.querySelectorAll('.glow-split-lines');
    if (splitHeadings.length === 0) return;
    setTimeout(function() {
      splitHeadings.forEach(function(heading) {
        heading.querySelectorAll('.glow-split-line').forEach(function(line) {
          line.classList.add('is-revealed');
        });
      });
    }, 150);
  }

  /* Tag targets — skip shopify-section wrapper and <section> tags */
  var targets = [];
  var sectionMap = {};
  
  SECTION_SELECTORS.forEach(function(sel) {
    var wrapper = document.querySelector(sel);
    if (!wrapper) return;
    var el = wrapper;
    if (el.id && el.id.indexOf('shopify-section') === 0) el = el.firstElementChild || el;
    if (el.tagName === 'SECTION') {
      var div = el.querySelector(':scope > div, :scope > header, :scope > article');
      if (div) el = div;
    }
    el.classList.add('glow-reveal');
    targets.push(el);
    sectionMap[targets.length - 1] = wrapper;
  });

  /* Tag stagger children */
  var staggerParents = [];
  STAGGER_MAP.forEach(function(map) {
    var parents = document.querySelectorAll(map.parent);
    parents.forEach(function(parent) {
      var children = parent.querySelectorAll(map.children);
      children.forEach(function(child) { child.classList.add('glow-stagger-item'); });
      if (children.length > 0) staggerParents.push(parent);
    });
  });

  /* === UNIFIED: also handle data-section-animation === */
  /* Pause animations initially */
  document.querySelectorAll('[data-section-animation]').forEach(function(el) {
    el.style.animationPlayState = 'paused';
  });

  /* Section observer — fade in at 5% visible */
  var sectionObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        /* Handle glow-reveal */
        entry.target.classList.add('is-revealed');
        
        /* Handle data-section-animation on parent <section> */
        var section = entry.target.closest('[data-section-animation]');
        if (section) {
          section.style.animationPlayState = 'running';
        }
        /* Also check if the target itself has data-section-animation */
        if (entry.target.hasAttribute && entry.target.hasAttribute('data-section-animation')) {
          entry.target.style.animationPlayState = 'running';
        }
        
        /* Phase D: also reveal split-lines */
        var idx = targets.indexOf(entry.target);
        var searchRoot = (idx >= 0 && sectionMap[idx]) ? sectionMap[idx] : entry.target;
        revealSplitLines(searchRoot);
        
        sectionObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function(t) { sectionObs.observe(t); });

  /* P3: Assign animation variants to specific sections */
  var VARIANT_MAP = {
    'brand_innovation': 'glow-reveal-left',
    'trust_certs': 'glow-reveal-scale',
    'newsletter_incentive': 'glow-reveal-right',
    'guarantees': 'glow-reveal-right',
    'skin_diagnostic': 'glow-reveal-left'
  };
  targets.forEach(function(t, idx) {
    var wrapper = sectionMap[idx];
    if (!wrapper) return;
    var wid = wrapper.id || '';
    Object.keys(VARIANT_MAP).forEach(function(key) {
      if (wid.indexOf(key) !== -1) {
        t.classList.add(VARIANT_MAP[key]);
      }
    });
  });

  /* Stagger observer — reveal children sequentially */
  var staggerObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.glow-stagger-item').forEach(function(child) {
          child.classList.add('is-revealed');
        });
        staggerObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

  staggerParents.forEach(function(p) { staggerObs.observe(p); });
})();
